import { type Draft, produce } from 'immer';
import type { Reducer } from 'redux';
import { ActionTypes } from './actionTypes';
import type { DeviceConfigurationAction } from './actions';

import type { DeviceConfiguration, PageableContent, UpdateDeviceConfiguration } from '@cobliteam/common-types';

import { type WebData, webDataError, webDataFetching, webDataNotAsked, webDataSuccess } from '@cobliteam/api-lib';

export interface DeviceConfigurationState {
  deviceConfigurationWebData: WebData<PageableContent<DeviceConfiguration>>;
  updateDeviceConfigurationRequestWebData: WebData<UpdateDeviceConfiguration[]>;
  updateDeviceSpeedRequestWebData: WebData<UpdateDeviceConfiguration>;
}

export const deviceConfigurationInitialState: DeviceConfigurationState = {
  deviceConfigurationWebData: webDataNotAsked(),
  updateDeviceConfigurationRequestWebData: webDataNotAsked(),
  updateDeviceSpeedRequestWebData: webDataNotAsked(),
};

const deviceConfigurationReducer: Reducer<DeviceConfigurationState, DeviceConfigurationAction> = produce(
  (draft: Draft<DeviceConfigurationState>, action: DeviceConfigurationAction) => {
    switch (action.type) {
      case ActionTypes.LOAD_DEVICE_CONFIGURATION_REQUEST:
        draft.deviceConfigurationWebData = webDataFetching();
        break;
      case ActionTypes.LOAD_DEVICE_CONFIGURATION_SUCCEDED:
        draft.deviceConfigurationWebData = webDataSuccess(action.payload);
        break;
      case ActionTypes.LOAD_DEVICE_CONFIGURATION_FAILED:
        draft.deviceConfigurationWebData = webDataError();
        break;
      case ActionTypes.UPDATE_DEVICE_CONFIGURATION_REQUEST_REQUEST:
        draft.updateDeviceConfigurationRequestWebData = webDataFetching();
        break;
      case ActionTypes.UPDATE_DEVICE_CONFIGURATION_REQUEST_SUCCEDED:
        draft.updateDeviceConfigurationRequestWebData = webDataSuccess(action.payload);
        break;
      case ActionTypes.UPDATE_DEVICE_CONFIGURATION_REQUEST_FAILED:
        draft.updateDeviceConfigurationRequestWebData = webDataError();
        break;
      case ActionTypes.UPDATE_DEVICE_SPEED_REQUEST_REQUEST:
        draft.updateDeviceSpeedRequestWebData = webDataFetching();
        break;
      case ActionTypes.UPDATE_DEVICE_SPEED_REQUEST_SUCCEDED:
        draft.updateDeviceSpeedRequestWebData = webDataSuccess(action.payload);
        break;
      case ActionTypes.UPDATE_DEVICE_SPEED_REQUEST_FAILED:
        draft.updateDeviceSpeedRequestWebData = webDataError();
        break;
    }
  },
  deviceConfigurationInitialState
);

export default deviceConfigurationReducer;
